import React from 'react';
import Screen1_Landing from './pages/Screen1_Landing';

function App() {
  return <Screen1_Landing />;
}

export default App;
